// "just now", "3 min ago", "2 h ago": how long ago something happened, for people rather than clocks.
export function formatAge(from: Date | string, now: Date): string {
  const seconds = Math.max(0, Math.round((now.getTime() - new Date(from).getTime()) / 1000));
  if (seconds < 45) {
    return 'just now';
  }
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) {
    return `${minutes} min ago`;
  }
  const hours = Math.floor(minutes / 60);
  return hours < 24 ? `${hours} h ago` : `${Math.floor(hours / 24)} d ago`;
}
